import React from 'react';
import { FormattedMessage } from 'react-intl';

import { walletProviderApprovalPendingMessageBuilder } from './message-props-builders/wallet-provider-approval-pending';

const isMatchForWalletPendingApproval = (errorMessage) => errorMessage?.toLowerCase()?.includes('pending internal approval');

/**
 * Parses error message and augments if it matches specific criteria
 * Currently only supports wallet provider approval pending messages
 * @typedef {import('../../prop-types/intl').MessageDescriptorPropType} MessageDescriptor
 * @param {string | MessageDescriptor | JSX.Element} errorString
 * @param {boolean} shouldFormatMessage - specifies if the non-string return type should be a FormattedMessage instead of a MessageDescriptor
 * @returns {string | MessageDescriptor | JSX.Element}
 */
export const getMessageDescriptorOrStringFromErrorString = (errorString, shouldFormatMessage) => {
  if (typeof errorString !== 'string') {
    return errorString;
  }

  if (isMatchForWalletPendingApproval(errorString)) {
    const message = walletProviderApprovalPendingMessageBuilder();
    if (shouldFormatMessage) {
      return <FormattedMessage {...message} />;
    }
    return message;
  }

  return errorString;
};
